// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sync-block__backdrop {
  z-index: 11000 !important;
}

.sync-block__sheet.player-session-results__sheet {
  max-width: 480px;
  --sync-bg: var(--bg-color, #f5f8fa);
  --sync-surface: var(--surface-color, #ffffff);
  --sync-text: var(--text-color, #1a2b3c);
  --sync-muted: var(--text-secondary, #78909c);
  --sync-border: var(--border-color, #e2e8f0);
  color: var(--sync-text);
  color-scheme: light dark;
}

.dark-mode .sync-block__sheet,
.sync-block__sheet.dark-mode,
html[data-theme="dark"] .sync-block__sheet {
  --sync-bg: var(--bg-color, #0f172a);
  --sync-surface: var(--surface-color, #111827);
  --sync-text: var(--text-color, #f9fafb);
  --sync-muted: var(--text-secondary, #9ca3af);
  --sync-border: rgba(255, 255, 255, 0.12);
}

.sync-block__subtitle {
  margin-top: 4px !important;
}

.sync-block__source {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px 10px;
  margin: 10px 0 0;
  font-size: 13px;
}

.sync-block__source-label {
  font-weight: 700;
  color: var(--sync-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 11px;
}

.sync-block__source-name {
  font-weight: 750;
  color: var(--sync-text);
}

.sync-block__toolbar {
  display: flex;
  gap: 12px;
  padding: 0 16px 8px;
}

.sync-block__link {
  border: none;
  background: transparent;
  color: var(--brand-primary, #0877bc);
  font: inherit;
  font-size: 12px;
  font-weight: 750;
  cursor: pointer;
  padding: 0;
}

.sync-block__link:disabled {
  opacity: 0.45;
  cursor: default;
}

.sync-block__body.player-session-results__body {
  padding: 8px 16px 16px !important;
  background: var(--sync-bg) !important;
  color: var(--sync-text);
}

.sync-block__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sync-block__row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid var(--sync-border);
  background: var(--sync-surface);
  color: var(--sync-text);
  cursor: pointer;
  font: inherit;
}

.sync-block__row--on {
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 45%, var(--sync-border));
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--sync-surface));
}

.sync-block__row input {
  width: 18px;
  height: 18px;
  accent-color: var(--brand-primary, #0877bc);
}

.sync-block__swatch {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.sync-block__row-label {
  font-size: 14px;
  font-weight: 700;
  color: var(--sync-text);
}

.sync-block__mode {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 14px;
  font-size: 12px;
  font-weight: 650;
  color: var(--sync-muted);
  line-height: 1.35;
}

.sync-block__mode input {
  margin-top: 2px;
  accent-color: var(--brand-primary, #0877bc);
}

.sync-block__empty {
  margin: 8px 0;
  font-size: 13px;
  font-weight: 650;
  color: var(--sync-muted);
}

.sync-block__footer {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 12px 16px 20px;
  border-top: 1px solid var(--sync-border);
  background: var(--sync-surface);
}

.sync-block__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 8px 16px;
  border-radius: 12px;
  border: 1px solid var(--sync-border);
  background: var(--sync-surface);
  color: var(--sync-text);
  font: inherit;
  font-size: 13px;
  font-weight: 750;
  cursor: pointer;
}

.sync-block__btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.sync-block__btn--ghost {
  color: var(--brand-primary, #0877bc);
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 35%, var(--sync-border));
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--sync-surface));
}

.sync-block__btn--primary {
  color: #fff;
  border: none;
  background: linear-gradient(
    135deg,
    var(--brand-primary, #0877bc) 0%,
    var(--brand-primary-dark, #065a8f) 100%
  );
}
`, "",{"version":3,"sources":["webpack://./src/components/planning/SyncBlockExerciseDialog.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,6CAA6C;EAC7C,uCAAuC;EACvC,4CAA4C;EAC5C,2CAA2C;EAC3C,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;;EAGE,mCAAmC;EACnC,6CAA6C;EAC7C,uCAAuC;EACvC,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,uBAAuB;EACvB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,uFAAuF;EACvF,sFAAsF;AACxF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,uBAAuB;EACvB,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,uFAAuF;EACvF,sFAAsF;AACxF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;;;;GAIC;AACH","sourcesContent":[".sync-block__backdrop {\n  z-index: 11000 !important;\n}\n\n.sync-block__sheet.player-session-results__sheet {\n  max-width: 480px;\n  --sync-bg: var(--bg-color, #f5f8fa);\n  --sync-surface: var(--surface-color, #ffffff);\n  --sync-text: var(--text-color, #1a2b3c);\n  --sync-muted: var(--text-secondary, #78909c);\n  --sync-border: var(--border-color, #e2e8f0);\n  color: var(--sync-text);\n  color-scheme: light dark;\n}\n\n.dark-mode .sync-block__sheet,\n.sync-block__sheet.dark-mode,\nhtml[data-theme=\"dark\"] .sync-block__sheet {\n  --sync-bg: var(--bg-color, #0f172a);\n  --sync-surface: var(--surface-color, #111827);\n  --sync-text: var(--text-color, #f9fafb);\n  --sync-muted: var(--text-secondary, #9ca3af);\n  --sync-border: rgba(255, 255, 255, 0.12);\n}\n\n.sync-block__subtitle {\n  margin-top: 4px !important;\n}\n\n.sync-block__source {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 6px 10px;\n  margin: 10px 0 0;\n  font-size: 13px;\n}\n\n.sync-block__source-label {\n  font-weight: 700;\n  color: var(--sync-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  font-size: 11px;\n}\n\n.sync-block__source-name {\n  font-weight: 750;\n  color: var(--sync-text);\n}\n\n.sync-block__toolbar {\n  display: flex;\n  gap: 12px;\n  padding: 0 16px 8px;\n}\n\n.sync-block__link {\n  border: none;\n  background: transparent;\n  color: var(--brand-primary, #0877bc);\n  font: inherit;\n  font-size: 12px;\n  font-weight: 750;\n  cursor: pointer;\n  padding: 0;\n}\n\n.sync-block__link:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.sync-block__body.player-session-results__body {\n  padding: 8px 16px 16px !important;\n  background: var(--sync-bg) !important;\n  color: var(--sync-text);\n}\n\n.sync-block__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.sync-block__row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 48px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  border: 1px solid var(--sync-border);\n  background: var(--sync-surface);\n  color: var(--sync-text);\n  cursor: pointer;\n  font: inherit;\n}\n\n.sync-block__row--on {\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 45%, var(--sync-border));\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--sync-surface));\n}\n\n.sync-block__row input {\n  width: 18px;\n  height: 18px;\n  accent-color: var(--brand-primary, #0877bc);\n}\n\n.sync-block__swatch {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.sync-block__row-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--sync-text);\n}\n\n.sync-block__mode {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-top: 14px;\n  font-size: 12px;\n  font-weight: 650;\n  color: var(--sync-muted);\n  line-height: 1.35;\n}\n\n.sync-block__mode input {\n  margin-top: 2px;\n  accent-color: var(--brand-primary, #0877bc);\n}\n\n.sync-block__empty {\n  margin: 8px 0;\n  font-size: 13px;\n  font-weight: 650;\n  color: var(--sync-muted);\n}\n\n.sync-block__footer {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  padding: 12px 16px 20px;\n  border-top: 1px solid var(--sync-border);\n  background: var(--sync-surface);\n}\n\n.sync-block__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n  padding: 8px 16px;\n  border-radius: 12px;\n  border: 1px solid var(--sync-border);\n  background: var(--sync-surface);\n  color: var(--sync-text);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.sync-block__btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.sync-block__btn--ghost {\n  color: var(--brand-primary, #0877bc);\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 35%, var(--sync-border));\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--sync-surface));\n}\n\n.sync-block__btn--primary {\n  color: #fff;\n  border: none;\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary, #0877bc) 0%,\n    var(--brand-primary-dark, #065a8f) 100%\n  );\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
